import React, { useState } from 'react';
import { Dropdown, Badge, Spinner } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const UserProfile = () => {
    const { user, logout, loading, ssoEnabled, isAdmin, isHRUser } = useAuth();
    const [loggingOut, setLoggingOut] = useState(false);

    if (loading) {
        return (
            <Spinner animation="border" size="sm" variant="light" />
        );
    }

    if (!user) {
        return null;
    }

    const handleLogout = async () => {
        setLoggingOut(true);
        try {
            await logout();
        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            setLoggingOut(false);
        }
    };

    const getRoleBadgeVariant = (role) => {
        switch (role) {
            case 'HR.Admin':
                return 'danger';
            case 'HR.User':
                return 'warning';
            case 'Viewer':
                return 'info';
            default:
                return 'secondary';
        }
    };

    const getDisplayName = () => {
        if (user.name) return user.name;
        if (user.given_name && user.family_name) {
            return `${user.given_name} ${user.family_name}`;
        }
        return user.email || 'User';
    };

    return (
        <Dropdown align="end">
            <Dropdown.Toggle variant="outline-light" id="user-dropdown" className="d-flex align-items-center">
                <i className="fas fa-user-circle me-2"></i>
                <span className="d-none d-md-inline">{getDisplayName()}</span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Header>
                    <div className="fw-bold">{getDisplayName()}</div>
                    <small className="text-muted">{user.email}</small>
                    <div className="mt-2">
                        {user.roles?.map((role, index) => (
                            <Badge 
                                key={index} 
                                bg={getRoleBadgeVariant(role)} 
                                className="me-1"
                            >
                                {role}
                            </Badge>
                        ))}
                    </div>
                </Dropdown.Header>
                
                <Dropdown.Divider />
                
                <Dropdown.Item disabled>
                    <i className="fas fa-info-circle me-2"></i>
                    Permissions:
                </Dropdown.Item>
                
                <Dropdown.Item disabled className="small text-muted ps-4">
                    {isAdmin() && "• Full administrative access"}
                    {isHRUser() && !isAdmin() && "• Upload and process files"}
                    {!isHRUser() && "• View results only"}
                </Dropdown.Item>
                
                <Dropdown.Divider />
                
                {ssoEnabled && (
                    <Dropdown.Item onClick={handleLogout} disabled={loggingOut}>
                        {loggingOut ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                                Signing out...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-sign-out-alt me-2"></i>
                                Sign out
                            </>
                        )}
                    </Dropdown.Item>
                )}
                
                {!ssoEnabled && (
                    <Dropdown.Item disabled>
                        <i className="fas fa-code me-2"></i>
                        Development Mode
                    </Dropdown.Item>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default UserProfile;
